import { useState } from 'react';
import useEventListener from '@use-it/event-listener';

export default function useClickOutside<T extends HTMLElement>(
  callback: (ev: MouseEvent) => void,
) {
  const [element, setElement] = useState<T | null>(null);

  useEventListener(
    'click',
    (ev: MouseEvent) => {
      if (!element?.contains(ev.target as Node)) callback(ev);
    },
    document,
    { capture: true },
  );

  return setElement;
}
